import { gql } from 'graphql-request'

export const ListUnprocessedLotsGql = gql`
  query listUnprocessedLots($stationRecordNumber: String!) {
    listUnprocessedLots(request: { stationRecordNumber: $stationRecordNumber }) {
      internalReferenceCode
      saleNumber
      purchaseDescription
      totalBales
      netKg
      lineNumber
      commissionPaymentDate
    }
  }
`
